<!--签署统计折线图-->
<!--author:yf-->
<template>
  <div style="position:relative;width: 100%;height: 100%;">
    <div style="width:100%;height:100%;" :id="id"></div>
    <div v-if="chartData.xAxis.length===0" class="common-noData">暂无数据</div>
  </div>
</template>
<script>
  let echarts = require('echarts/lib/echarts'); // 引入基本模板
  require('echarts/lib/chart/line');
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/dataZoom');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/title')

  const merge = require('webpack-merge');

  export default {
    name: 'ChartLine',
    data() {
      return {
        myChart: '',
      };
    },
    props: {
      id: { // 分配渲染的盒子id
        type: String,
        default: 'ChartBox',
      },
      chartData: { // 渲染的节点数据及节点颜色
        type: Object,
        default() {
          return {
            title:'',
            xAxis:['2016', '2017', '2018', '2019', '2020', '2021', '2022'],
            data:[100,20,50,40,90,10,40]
          }
        }
      },
      option: {
        type: Object,
        default: function () {
          return {};
        },
      },
    },
    mounted() {
      this.myChart = echarts.init(document.getElementById(this.id));
      this.showLoading(); // 数据获取显示之前先加载一段动画
      this.draw();
    },
    methods: {
      // 使用说明：
      // 无数据时显坐标轴并显示无数据
      getOption() {
        let defaultOption = {
          // title: {text: this.chartData.title, x: 'center', y: 'center', textStyle: {color: 'rgba(41, 2, 2, 1)', fontSize: 14}},
          grid:{containLabel:true,left:'3%',right:'3%',top:'5%',bottom:'5%'},
          tooltip: {
            backgroundColor: '#ffffff',
            borderColor:'rgba(0, 0, 0, 0.16)',
            borderWidth:1,
            trigger: 'axis',
            textStyle:{
              color:'rgba(116, 90, 90, 1)'
            },
            axisPointer:{
              type:'shadow',
              shadowStyle:{
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(0,0,0,0.03)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(0,0,0,0.06)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            }
          },
          xAxis: {
            type: 'category',
            offset:10,
            // boundaryGap:false,
            data: this.chartData.xAxis,
            axisTick:{
              show:false
            },
            axisLine:{
              show:false
            },
            nameTextStyle:{
              color:'rgba(41, 2, 2, 0.65)'
            }
          },
          yAxis: {
            type: 'value',
            offset:5,
            splitArea:{
              show:true,
              areaStyle:{
                color:['rgba(248, 248, 248, 1)','transparent']
              }
            },
            splitLine:{
              show:false
            },
            axisTick:{
              show:false
            },
            axisLine:{
              show:false
            },
            nameTextStyle:{
              color:'rgba(41, 2, 2, 0.65)'
            }
          },
          series: [{
            smooth:0.2,
            lineStyle:{
              color:'rgba(255, 184, 72, 1)'
            },
            symbol:'circle',
            symbolSize:8,
            data: this.chartData.data,
            type: 'line',
            itemStyle:{
              color:'rgba(255, 184, 72, 1)'
            }
          }]
        }

        this.chartData.xAxis.length && (defaultOption.dataZoom={
          type:'inside'
        })
        if (Object.keys(this.option).length) {
          defaultOption = merge(defaultOption, this.option);
        }
        return defaultOption;
      },
      draw() { // 绘制图表
        this.hideLoading();
        this.myChart.clear();
        this.resetChartData();
      },
      resetChartData() { // 刷新数据
        this.myChart.setOption(this.getOption(), true);
        this.hideLoading();
      },
      showLoading() { // 显示加载动画
        this.myChart.showLoading();
      },
      hideLoading() { // 关闭加载动画
        this.myChart.hideLoading();
      },
      resize(){
        this.myChart.resize()
      }
    },
    watch: {
      chartData:{
        handler(n,o){
          this.resetChartData();
        },
        // immediate: true,  //刷新加载 立马触发一次handler
        deep: true  // 可以深度检测到 person 对象的属性值的变化
      }
    },
    beforeDestroy() {
      this.myChart && this.myChart.dispose();
    },
  }
</script>
<style scoped>
  .common-noData {
    color: rgba(41, 2, 2, .45);
    text-align: center;
    position: absolute;
    width: 100%;
    left: 0;
    top: 50%;
    margin-top: -10px;
  }
</style>




// WEBPACK FOOTER //
// components/charts/charts-line-new.vue